exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lineage-container {\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    overflow: hidden;\n}\n\n.lineage-react-flow-wrapper {\n    flex: 1;\n    position: relative;\n    height: 100%;\n}\n\n.lineage-selected-node {\n    width: 40%;\n    position: relative;\n    height: 100%;\n    overflow: auto;\n}\n", ""]);

